import { Meta, theme } from 'aimo-ui';
import PoolingBadge from 'components/park/PoolingBadge';
import { format } from 'date-fns';
import useGetMatchingPermitsForParkingZone from 'hooks/useGetMatchingPermitsForParkingZone';
import { default as React } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import styled from 'styled-components/native';
import { StyledContainer } from 'styles/ContainerStyles';
import { Maybe, ParkZone } from 'types/generatedSchemaTypes';
import { getLocale } from 'utils/commonUtils';
import ParkingLoyaltyPermits from '../ParkingLoyaltyPermits';
import ParkingPrepaidTickets from '../ParkingPrepaidTickets';
import Tariff from '../tariff/Tariff';

type ParkingZoneParkTabProps = {
  parkZone?: Maybe<ParkZone>;
};

const StyledMeta = styled(Meta)`
  padding: 4px;
  font-weight: 500;
`;

const ResumeInfoBox = styled(StyledContainer)`
  border-radius: 20px;
  margin-bottom: 15px;
`;

const PoolingBadgeWrapper = styled.View`
  margin-bottom: 15px;
`;

const ParkingZoneParkTab: React.FC<ParkingZoneParkTabProps> = ({
  parkZone,
}: ParkingZoneParkTabProps) => {
  const resumableSessionInfo = useParkingStore(
    (state) => state.resumableSession
  );
  const { t } = useTranslation();

  const {
    groupedMatchingPermits: { ACCESS: accessPermits },
  } = useGetMatchingPermitsForParkingZone(parkZone?.uid, ['ACCESS']);

  //It's unlikely for the customer to have more than one permit for the same parking zone
  // and even if they did, we don't want to bloat the interface with multiple badges
  const matchingAccessPermit = accessPermits?.[0];

  //Will be used for the loyalty permit badge with remaining time left
  /*const matchingLoyaltyPermit =
    useGetSelectedOrFirstVehicleMatchingPermit(loyaltyPermits);*/

  return (
    <View>
      {resumableSessionInfo && (
        <ResumeInfoBox
          color={theme.colors.infoYellow}
          testID={'resumable-session-info'}>
          <StyledMeta color={theme.colors.black}>
            {t('parking.resumeSession', {
              startTime: format(
                new Date(resumableSessionInfo.startDate || ''),
                'kk:mm',
                { locale: getLocale() }
              ),
            })}
          </StyledMeta>
        </ResumeInfoBox>
      )}
      {matchingAccessPermit && (
        <PoolingBadgeWrapper>
          <PoolingBadge parkingZoneUid={parkZone?.uid} />
        </PoolingBadgeWrapper>
      )}
      <Tariff borderTop color={theme.colors.black} />
      <ParkingPrepaidTickets />
      <ParkingLoyaltyPermits />
    </View>
  );
};

export default React.memo(ParkingZoneParkTab);
